<!-- Trigger. Mirrors the smart-inbox assignee control: leading glyph (the icon,
     or the selected person's avatar), label, chevron. -->
<button
  type="button"
  class="filter-select__trigger"
  [class.filter-select__trigger--ghost]="variant === 'ghost'"
  [class.filter-select__trigger--pill]="shape === 'pill'"
  [class.filter-select__trigger--active]="isActive"
  [ngStyle]="activeTriggerStyle"
  [matMenuTriggerFor]="optionsMenu"
  (menuOpened)="onOpen()"
  [attr.aria-label]="ariaLabel || placeholder"
>
  <span
    class="filter-select__avatar"
    *ngIf="selected?.avatar as avatar; else triggerGlyph"
    [style.background]="avatar.image ? 'transparent' : avatar.color"
  >
    <img *ngIf="avatar.image; else triggerInitials" [src]="'data:image/jpeg;base64,' + avatar.image" [alt]="selected!.label" />
    <ng-template #triggerInitials>{{ avatar.initials }}</ng-template>
  </span>

  <!-- The icon is what names the control, so it stays put while the filter
       changes. An avatar is the one exception: it identifies the person more
       directly than a generic user glyph, which is how the smart-inbox assignee
       control reads too. -->
  <ng-template #triggerGlyph>
    <ui-icon *ngIf="icon" [name]="icon" size="medium" class="filter-select__icon"></ui-icon>
  </ng-template>

  <span class="filter-select__label">{{ triggerLabel }}</span>
  <ui-icon name="ChevronDown" size="medium" class="filter-select__caret"></ui-icon>
</button>

<mat-menu #optionsMenu="matMenu" class="filter-select-menu" panelClass="filter-select-menu-panel">
  <ng-template matMenuContent>
    <!-- Typing in the search box must not bubble out and close the menu, but the
         guard has to let the menu's own keys through — see `onPanelKeydown`. -->
    <div class="filter-select__panel" (click)="$event.stopPropagation()" (keydown)="onPanelKeydown($event)">
      <div class="filter-select__search" *ngIf="searchable">
        <input
          type="text"
          cdkFocusInitial
          [formControl]="searchControl"
          [placeholder]="searchPlaceholder"
          autocomplete="off"
        />
        <mat-spinner *ngIf="loading" diameter="14" class="filter-select__spinner"></mat-spinner>
        <ui-icon *ngIf="!loading" name="Search" size="small" class="filter-select__search-icon"></ui-icon>
      </div>

      <div class="filter-select__options">
        <ng-container *ngFor="let option of options; trackBy: trackByValue">
          <hr class="filter-select__separator" *ngIf="option.separatorBefore" />
          <button
            type="button"
            class="filter-select__option"
            [class.filter-select__option--selected]="isSelected(option)"
            (click)="select(option)"
          >
            <span
              class="filter-select__avatar"
              *ngIf="option.avatar as avatar"
              [style.background]="avatar.image ? 'transparent' : avatar.color"
            >
              <img *ngIf="avatar.image; else optionInitials" [src]="'data:image/jpeg;base64,' + avatar.image" [alt]="option.label" />
              <ng-template #optionInitials>{{ avatar.initials }}</ng-template>
            </span>
            <span class="filter-select__dot" *ngIf="!option.avatar && option.dotColor" [style.background]="option.dotColor"></span>

            <span class="filter-select__option-text">
              <span class="filter-select__option-label">{{ option.label }}</span>
              <span class="filter-select__option-sublabel" *ngIf="option.sublabel">{{ option.sublabel }}</span>
            </span>
            <span class="filter-select__badge" *ngIf="option.badge">{{ option.badge }}</span>
            <span class="filter-select__count" *ngIf="option.count !== null && option.count !== undefined">{{ option.count }}</span>
            <ui-icon *ngIf="isSelected(option)" name="Check" size="medium" class="filter-select__check"></ui-icon>
          </button>
        </ng-container>

        <div class="filter-select__empty" *ngIf="isEmpty && !loading">{{ emptyLabel }}</div>
      </div>
    </div>
  </ng-template>
</mat-menu>
